module.exports = __webpack_public_path__ + "static/media/logo-bodyshock.2461d63c.svg";